module.exports = __webpack_public_path__ + "static/media/calouros.1edf6e59.jpg";